const component = () => import('./SessionsPage.vue');

export default [
  {
    path: '/v5/sessions',
    name: 'V5_sessions',
    component,
    // Early v5 links put the session in ?session=
    beforeEnter: (to) => {
      const { session, ...query } = to.query;
      return session ? { path: `/v5/sessions/${session}`, query } : true;
    },
  },
  { path: '/v5/sessions/:uuid', name: 'V5_session', component },
];
